import './tooltip.scss';

export { Tooltip } from '@lambdacurry/component-library';